import React from 'react';
import './ParticleBackground.css';

const ParticleBackground: React.FC = () => {
  return (
    <div className="bg-blobs">
      <div className="blob blob-1" />
      <div className="blob blob-2" />
      <div className="blob blob-3" />
      <div className="blob blob-4" />
    </div>
  );
};

export default ParticleBackground;
